import { ListViewModel } from './view.model';

 export class ListViewsLoadAction {
   constructor(public views: ListViewModel[]) {
   }
 }
